<template>
  <div class="main">
    <div id="SlotMachine">
      <div class="container" style="padding-top:150px">
<!--        <Gift-->
<!--            v-for="(config, index) in configs"-->
<!--            @finished="isFinished"-->
<!--            :trigger="trigger"-->
<!--            :config="config"-->
<!--            :key="index">-->
<!--        </Gift>-->
        <Gift
            :trigger="trigger"
            :config="configs[0]"
            >
        </Gift>
        <Gift
            :trigger="trigger"
            :config="configs[1]"
            >
        </Gift>
        <Gift
            :trigger="trigger"
            :config="configs[2]"
        >
        </Gift>
        <Gift
            :trigger="trigger"
            :config="configs[3]"
            @finished="isFinished"
            >
        </Gift>
      </div>

      <a role="button" class="btn btn-primary start" href="#"  @click="turn" :disabled="disabled" v-if="ShowStartButton">開始抽獎</a>
      <a role="button" class="btn btn-primary sms" href="#"  @click="sendSMS"  v-if="ShowStartButton">傳送中獎簡訊  {{smsMsg}}</a>
      <a role="button" class="btn btn-primary setting" href="#"  @click="setting" >設定 {{EventItemInfo}}</a>

<!--      <a-->
<!--          class="start"-->
<!--          @click="turn"-->
<!--          :disabled="disabled">-->
<!--        START-->
<!--      </a>-->
<!--      <a-->
<!--          class="setting"-->
<!--          @click="setting"-->
<!--          >-->
<!--        設定 {{EventItemInfo}}-->
<!--      </a>-->
    </div>


    <div class="info">
      {{GetUserInfo1}} <br>
      {{GetUserInfo2}} <br>
      {{GetUserInfo3}} <br>

    </div>

    <DLGEventItems ref="dlgEventItems" v-on:returnAdd="dlgEventItemsReturnAdd" v-on:returnRemove="dlgEventItemsReturnRemove"   v-on:returnSelect="dlgEventItemsReturnSelect" />
  </div>

</template>

<script>
import Gift from './Gift'
import DLGEventItems from "@/views/checkInAdmin/Event/DLGEventItems";
import util from "@/util/util";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
export default {
  name: 'SlotMachine',
  components: {
    DLGEventItems,
    Gift
  },
  data () {
    return {
      trigger: null,
      disabled: true,
      configs: [
        {
          duration: 4000,
          fontSize: 100,
          height: 100,
          width: 200,
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'text', name: index } })
        },
        {
          duration: 4000,
          fontSize: 100,
          height: 100,
          width: 200,
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'text', name: index } })
        },
        {
          duration: 5000,
          fontSize: 100,
          height: 100,
          width: 200,
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'text', name: index } })
        },
        {
          duration: 6000,
          fontSize: 100,
          height: 100,
          width: 200,
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'text', name: index } })
        }
      ],
      result: [],
      resultHistory: [],
      SystemId:"",
      EventItemInfo:"",
      MemberInQueue:[],
      MemberInQueueGeted:[],

      GetUserInfoSystemId:"",
      GetUserInfo1:"_",
      GetUserInfo2:"_",
      GetUserInfo3:"_",
      ShowStartButton:false,
      smsMsg:"",
    }
  },
  methods: {
    turn () {
      this.disabled = true
      this.trigger = new Date()
    },
    isFinished (val) {
      const autoTurnList = this.$el.querySelectorAll('.autoTurn')
      this.result.push(val)
      if (autoTurnList.length === 1) {
        this.disabled = false
        this.resultHistory.push(this.result)
        this.result = []
      }
      // console.log(this.resultHistory)


      console.log("isFinished:"+val)

      let rndValue=util.getRandom(0,this.MemberInQueue.length-1);

      if (rndValue<this.MemberInQueue.length){
        this.GetUserInfoSystemId=this.MemberInQueue[rndValue].SystemId;
        this.GetUserInfo1=this.MemberInQueue[rndValue].info3;
        this.GetUserInfo2=this.MemberInQueue[rndValue].info1;
        this.GetUserInfo3=this.MemberInQueue[rndValue].info2;

        this.MemberInQueueGeted.push(this.MemberInQueue[rndValue]);
        this.MemberInQueue.splice(rndValue,1);
      }else{
        this.this.GetUserInfoSystemId="";
        this.GetUserInfo1="_";
        this.GetUserInfo2="_";
        this.GetUserInfo3="_";
      }

    },
    setting () {
      this.$refs.dlgEventItems.Mode="2";
      this.$refs.dlgEventItems.EventSystemId=this.SystemId;
      this.$refs.dlgEventItems.showModal();


    },
    sendSMS(){
      let that=this;
      let loader=util.ShowLoading(this);

      apiCheckIn.api_SendSMS(this.GetUserInfoSystemId).then((data)=>{ /*eslint-disable */
        that.smsMsg="(簡訊已發送至:" +  that.GetUserInfo2 + ")";
        util.HideLoading(loader);
      });
    },
    dlgEventItemsReturnAdd(items){  // eslint-disable-line

    },
    dlgEventItemsReturnRemove(items){  // eslint-disable-line


    },

    dlgEventItemsReturnSelect(items){ // eslint-disable-line
      if (items.length !==1) {
        alert("請選擇一個場次");
        return;
      }

      let that=this;
      let loader=util.ShowLoading(this);

      apiCheckIn.api_GetMemberIsCheckIn(this.SystemId,items).then((data)=>{
        that.MemberInQueue=data.data;
        that.EventItemInfo= "(總抽獎人數:" + that.MemberInQueue.length  +")";

        if (that.MemberInQueue.length>0){
          that.disabled = false;
          that.ShowStartButton=true;
        }

        util.HideLoading(loader);
      });

    },

  },
  mounted() {
    this.SystemId=this.$route.query.SystemId


  }
}
</script>

<style lang="scss">
.main{
  background-image: url("/checkin/background_game.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

}

.info{
  position: absolute;
  top: 47vh;
  left: 137vh;
  width: 300px;
  //height: 100%;
  //background-color: rgba(0,0,0,0.5);
  color: black;
  font-size: 35px;
  text-align: center;
  padding-top: 50px;
  white-space:nowrap;
}
#SlotMachine {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  .container {
    display: flex;
  }
  .start {
    position: absolute;
    bottom: 10vh;
    left:30vw;
    padding: 15px 30px;
    outline: none;
    border: none;
    border-radius: 10px;
    background-color: #023761;
    color: #ffffff;
    cursor: pointer;
    transition: 150ms;
    user-select: none;
    &:disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
    //padding-left: 40px;
    width: 200px;
  }
  .setting {
    position: absolute;
    bottom: 10vh;
    left:50vw;
    padding: 15px 30px;
    outline: none;
    border: none;
    border-radius: 10px;
    background-color: #023761;
    color: #ffffff;
    cursor: pointer;
    transition: 150ms;
    user-select: none;
    &:disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
    //padding-left: 140px;
    width: 200px;
  }
  .sms {
    position: absolute;
    bottom: 10vh;
    left:40vw;
    padding: 15px 30px;
    outline: none;
    border: none;
    border-radius: 10px;
    background-color:#023761;
    color: #ffffff;
    cursor: pointer;
    transition: 150ms;
    user-select: none;
    &:disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
    //padding-left: 240px;
    width: 200px;
  }
}
</style>
